import { IconCheck, IconClose, IconX } from '$partials/icons';
import { Button } from '$partials/ui';
import { formatLinkBlockToUrl } from '$utilities/format';
import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').SubscriptionBlock}
 */

const Subscription = ({
    additionalText,
    title,
    text,
    options
}) => {

    return (
        <div className='bg-surface-panel-blue col-wrapper-breakout rounded-lg flex-grow'>
            <div className='col-padding pt-24 pb-16'>
                <h2 className='type-style-sans-h1 w-full md:w-5/12'>
                    {title}
                </h2>
                {text && (
                    <p className='type-style-sans-h3 mt-8 w-full sm:w-7/12 md:w-5/12'>
                        {text}
                    </p>
                )}
                {options?.length > 0 && (
                    <div className='mt-16 md:mt-24 grid gap-x-16 sm:grid-cols-2'>
                        {options.map((option, idx) => {
                            return (
                                <div
                                    className={`${!idx ? 'bg-surface-raised': ''} p-24 sm:p-32 rounded-lg flex flex-col relative`}
                                    key={option.id}>
                                    {!idx && (
                                        <div className='flex self-start mb-12 sm:mb-0 sm:absolute top-24 right-24 sm:top-32 sm:right-32 tag-primary'>
                                            <p>
                                                {'Most popular'}
                                            </p>
                                        </div>
                                    )}
                                    <p className='type-style-sans-h3'>
                                        {option.title}
                                    </p>
                                    <p className='type-style-sans-body mt-8'>
                                        {option.text}
                                    </p>
                                    <p className='type-style-sans-body mt-8'>
                                        {option.priceText}
                                    </p>
                                    <div className='mt-32 flex flex-col gap-y-8'>
                                        {option.highlights.map(item => {
                                            return (
                                                <div
                                                    className='flex flex-row items-center gap-x-8'
                                                    key={item.id}>
                                                    {item.excluded ? <IconClose/> : <IconCheck/>}
                                                    <p className='type-style-sans-body'>
                                                        {item.highlight}
                                                    </p>
                                                </div>
                                            );
                                        })}
                                    </div>
                                    <Button
                                        as='a'
                                        className={`${idx ? 'button-outcome-xl': 'button-primary-xl'}${option.ctaCssClass ? ' ' + option.ctaCssClass : ''} mt-32 flex self-start`}
                                        href={formatLinkBlockToUrl(option.ctaLink)}>
                                        {option.ctaLabel}
                                    </Button>
                                </div>
                            );
                        })}
                    </div>
                )}
                {additionalText && (
                    <p className='text-center w-full mt-16'>
                        {additionalText}
                    </p>
                )}
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default Subscription;
